import type { Move } from "../types";

/**
 * Атаки прокачаны как в покемонах под разные роли:
 *   • На колени — мощно, но часто промах (стесняется)
 *   • Подползи — стабильно попадает, но урон 1..4 (большой разброс)
 *   • Мурлыкай — priority +1 (всегда первый), маленький урон
 *   • Проси — support: +1 HP и +50% уворот на текущий раунд
 */
export const MOVES: Move[] = [
  {
    id: "kneel",
    name: "На колени",
    description: "Сильный удар — 3 урона. Но промахивается часто.",
    kind: "attack",
    accuracy: 0.65,
    priority: 0,
    damageMin: 3,
    damageMax: 3,
    catboyPose: "kneel",
    flavorMiss: "слишком стеснителен и не слушается",
  },
  {
    id: "crawl",
    name: "Подползи",
    description: "Точно попадёт. Урон от 1 до 4 — как повезёт.",
    kind: "attack",
    accuracy: 1.0,
    priority: 0,
    damageMin: 1,
    damageMax: 4,
    catboyPose: "crawl",
    flavorMiss: "залип на месте от смущения",
  },
  {
    id: "purr",
    name: "Мурлыкай",
    description: "Бьёт первым в раунде. Но всего 1 урон.",
    kind: "attack",
    accuracy: 1.0,
    priority: 1,
    damageMin: 1,
    damageMax: 1,
    catboyPose: "purr",
    flavorMiss: "сбился и закашлялся",
  },
  {
    id: "beg",
    name: "Проси",
    description: "Зажмуриться: +1 HP и +50% уворот на этот раунд.",
    kind: "support",
    accuracy: 1.0,
    priority: 0,
    heal: 1,
    evadeBuff: 0.5,
    catboyPose: "beg",
    flavorMiss: "потерял дар речи",
  },
];

export const MOVE_BY_ID: Record<string, Move> = MOVES.reduce(
  (acc, m) => {
    acc[m.id] = m;
    return acc;
  },
  {} as Record<string, Move>,
);
